import css from 'styled-jsx/css';
import {
  colorHighlight,
  display,
  grayDarker,
  grayLighter,
  pageWidth,
  sansSerif,
  serif
} from 'styles/css-constants';
import { MQ_LARGE, MQ_MEDIUM, MQ_MIDLARGE } from 'constants/mq';

export default css`
  /* helps ceros embeds to render */
  .ItemBundle {
    width: 100%;
  }

  :global(.ItemBundle__cake) {
    margin-bottom: 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;
    font-family: ${sansSerif};
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  /* Sponsorship is Target specific right now. */
  :global(.ItemBundle__cake-name img) {
    margin-left: 0.25rem;
    max-width: 128px;
  }

  .ItemBundle__description {
    margin-bottom: 1rem;
    font-size: var(--fontScaleNeg1);
    text-align: center;
  }

  .ItemBundle__heading {
    font-family: ${display};
    font-size: var(--fontScale1);
    font-weight: bold;
    text-align: center;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  .ItemBundle--ad {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  /* Html formatting is currently geared towards embeds, but occurs */
  /* on the hardcoded K Thanksgiving sub-pages too                  */
  .ItemBundle :global(.Html p) {
    margin-bottom: 1rem;
  }

  .ItemBundle :global(.Ad) {
    margin: 1rem 0;
  }

  @media screen and ${MQ_MEDIUM} {
    .ItemBundle__heading {
      font-size: var(--fontScale2);
    }

    .ItemBundle :global(.Figure) {
      margin: 1rem auto;
      max-width: calc(100% - 2rem);
    }
  }

  @media screen and ${MQ_LARGE} {
    .ItemBundle {
      padding: 0;
    }

    :global(.ItemBundle__cake) {
      @include fontScale(-1);
    }

    .ItemBundle__description,
    .ItemBundle__heading {
      width: ${pageWidth.large};
    }

    .ItemBundle__description {
      margin-right: auto;
      margin-left: auto;
      font-size: var(--baseFontSize);
    }

    .ItemBundle__heading {
      margin: 0 auto 0.5rem;
      font-size: var(--fontScale2);
    }

    .ItemBundle :global(.EmailSignup),
    .ItemBundle :global(.Figure),
    .ItemBundle :global(.Html) {
      width: ${pageWidth.large};
      margin-right: auto;
      margin-left: auto;
    }
  }

  @media screen and ${MQ_MIDLARGE} {
    .ItemBundle__description,
    .ItemBundle__heading {
      width: ${pageWidth.midlarge};
    }

    .ItemBundle :global(.EmailSignup),
    .ItemBundle :global(.Figure),
    .ItemBundle :global(.Html) {
      width: ${pageWidth.midlarge};
    }
  }

  /* Default styling for a video interrupter bundle */
  .ItemBundle--video {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    background-color: var(--themeColor, #000);
  }

  .ItemBundle--video.theme--black,
  .ItemBundle--video.theme--gray {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .ItemBundle--video .ItemBundle__heading {
    margin-bottom: 0.5rem;
    color: #000;
  }

  .ItemBundle--video.theme--black .ItemBundle__heading {
    color: #fff;
  }

  .ItemBundle--video .ItemBundle__description {
    color: ${grayLighter};
  }

  @media screen and ${MQ_MEDIUM} {
    .ItemBundle--video {
      padding-right: 1.5rem;
      padding-left: 1.5rem;
    }

    .ItemBundle--video.theme--black,
    .ItemBundle--video.theme--gray {
      padding-top: 0.5rem;
      padding-bottom: 1.5rem;
    }
  }

  @media screen and ${MQ_LARGE} {
    .ItemBundle--video.theme--black,
    .ItemBundle--video.theme--gray {
      padding-top: 1rem;
      padding-bottom: 1.5rem;
    }

    .ItemBundle--video .ItemBundle__description {
      font-size: var(--baseFontSize);
    }

    .ItemBundle--video .ItemBundle__heading {
      margin-top: 0;
      margin-bottom: 1rem;
    }

    .ItemBundle--video :global(.Video) {
      margin: 0 auto;
      width: ${pageWidth.large};
    }
  }

  @media screen and ${MQ_MIDLARGE} {
    .ItemBundle--video.theme--black,
    .ItemBundle--video.theme--gray {
      padding-top: 2rem;
      padding-bottom: 2.125rem;
    }

    .ItemBundle--video.theme--black .ItemBundle__heading,
    .ItemBundle--video.theme--gray .ItemBundle__heading {
      margin-top: -1rem;
    }

    .ItemBundle--video .ItemBundle__description {
      margin-bottom: 1.5rem;
    }

    .ItemBundle--video .ItemBundle__heading {
      margin-bottom: 0.5rem;
      font-size: var(--fontScale3);
    }
  }

  /* Collection page styling for "html" bundle items */
  :global(.collection) .ItemBundle :global(.Html p) {
    padding: 0 1rem;
    color: ${grayDarker};
    font-family: ${serif};
    font-size: var(--fontScale1);
    line-height: 1.5;
  }

  :global(.collection) .ItemBundle :global(.Html p a) {
    border-bottom: 1px solid ${colorHighlight};
    color: #000;
  }

  :global(.collection)
    .ItemBundle
    :global(.Html p:first-of-type::first-letter) {
    float: left;
    margin-top: -0.075em;
    margin-right: 0.075em;
    display: block;
    color: ${colorHighlight};
    font-family: ${display};
    font-size: 3em;
    font-weight: bold;
    line-height: 1;
  }

  @media screen and ${MQ_MEDIUM} {
    :global(.collection) .ItemBundle :global(.Html p) {
      margin: 0 auto;
      width: 696px;
      padding: 0;
      font-size: var(--fontScale1);
    }
  }

  @media screen and ${MQ_MIDLARGE} {
    :global(.collection) .ItemBundle :global(.Html p) {
      width: 800px;
      font-size: var(--fontScale2);
    }
  }

  /* Special styling if an ItemBundle has the hero media for the page */
  .ItemBundle--hero.ItemBundle--video {
    padding: 0;
  }

  .ItemBundle--hero.ItemBundle--video :global(.Video) {
    width: 100%;
  }

  @media ${MQ_LARGE} {
    .ItemBundle--hero.ItemBundle--video :global(.Video) {
      width: ${pageWidth.large};
    }
  }

  @media screen and ${MQ_MIDLARGE} {
    .ItemBundle--hero.ItemBundle--video :global(.Video) {
      width: ${pageWidth.midlarge};
    }
  }

  /* Full bleed banner styles */
  :global(.ContentBundle--item-banner) .ItemBundle--image :global(.Figure) {
    margin-top: 0;
    width: 100%;
    max-width: none;
  }

  :global(.ContentBundle--item-banner)
    .ItemBundle--image
    :global(.Figure .Placeholder) {
    padding-bottom: 3%;
  }

  @media screen and ${MQ_LARGE} {
    :global(.ContentBundle--item-banner)
      .ItemBundle--image
      :global(.Figure .Placeholder) {
      height: 0;
      width: 100%;
      padding-bottom: 19.5%;
    }
  }

  /* Sponsorship styles */
  :global([data-page-path='/collection/dorm-therapy'] .PageHeader) {
    margin-bottom: -1rem;
  }

  :global([data-page-path='/collection/dorm-therapy']
      .ContentBundle--item:first-child
      .ItemBundle__cake-name
      .ItemBundle__cake-logo--target) {
    width: 2rem;
  }

  :global([data-page-path='/collection/dorm-therapy']
      .ContentBundle--item:first-child
      .ItemBundle__cake-messaging) {
    font-size: var(--fontScaleNeg2);
    letter-spacing: 0.1em;
  }

  @media screen and ${MQ_LARGE} {
    :global([data-page-path='/collection/dorm-therapy'] .PageHeader) {
      margin-bottom: 0;
    }

    :global([data-page-path='/collection/dorm-therapy']
        .ContentBundle--item:first-child
        .ItemBundle__cake-messaging) {
      font-size: var(--baseFontSize);
    }
  }

  :global([data-page-path='/collection/plant-design'])
    .ItemBundle
    :global(.Html p:first-of-type::first-letter) {
    color: #02373f;
  }

  :global([data-page-path='/collection/home-for-the-holidays'])
    .ItemBundle
    :global(.Html p:first-of-type::first-letter) {
    color: #de3730;
  }
`;
